import { TCartItem } from '../types/cart-item'

/**
 * Checks the service for the presence of a product in the cart
 * @param items - product in carts
 * @param relatedId - related product id from service data
 */
export const isServiceHasProduct = (items: TCartItem[], relatedId: number): boolean =>
	items.some(item => item.ID === Number(relatedId))
